// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccordionDocument .card-doc-header {
  background-color: #f7f7f7;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.3s ease-in-out;
}
.AccordionDocument .card-doc-title {
  font-size: 22px;
  color: #333;
}
.AccordionDocument .card-doc-button {
  background-color: #e8e8e8;
  color: #333;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
.AccordionDocument .customSuccessDoc {
  background-color: #27E6C4;
  color: #444258;
  border: 1px solid #27E6C4;
  padding: 5px 15px;
  font-size: 14px;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
.AccordionDocument .customViewDoc {
  background-color: #40c8ff;
  color: #ffffff;
  border: 1px solid #40c8ff;
  padding: 5px 15px;
  font-size: 14px;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
.AccordionDocument .customUploadDoc {
  background-color: white;
  color: #444258;
  border: 1px solid #444258;
  border-radius: 20px;
  padding: 5px 15px;
  font-size: 14px;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
.AccordionDocument .custom-error-doc {
  background-color: #EC6376;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 5px 15px;
  font-size: 14px;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/Views/Employee/EmployeeDocuments/AccordionDocuments.sass"],"names":[],"mappings":"AACE;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6CAAA;AAAJ;AAEE;EACE,eAAA;EACA,WAAA;AAAJ;AAEE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,qEAAA;AAAJ;AAEE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,qEAAA;AAAJ;AAEE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,qEAAA;AAAJ;AAEE;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qEAAA;AAAJ;AAEE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,qEAAA;AAAJ","sourcesContent":[".AccordionDocument\r\n  .card-doc-header\r\n    background-color: #f7f7f7\r\n    border: none\r\n    cursor: pointer\r\n    padding: 10px 20px\r\n    display: flex\r\n    justify-content: space-between\r\n    align-items: center\r\n    transition: background-color 0.3s ease-in-out\r\n\r\n  .card-doc-title\r\n    font-size: 22px\r\n    color: #333\r\n\r\n  .card-doc-button\r\n    background-color: #e8e8e8\r\n    color: #333\r\n    border: none\r\n    border-radius: 5px\r\n    padding: 5px 10px\r\n    font-size: 14px\r\n    cursor: pointer\r\n    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out\r\n\r\n  .customSuccessDoc\r\n    background-color: #27E6C4\r\n    color: #444258\r\n    border: 1px solid #27E6C4\r\n    padding: 5px 15px\r\n    font-size: 14px\r\n    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out\r\n\r\n  .customViewDoc\r\n    background-color: #40c8ff\r\n    color: #ffffff\r\n    border: 1px solid #40c8ff\r\n    padding: 5px 15px\r\n    font-size: 14px\r\n    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out\r\n\r\n  .customUploadDoc\r\n    background-color: white\r\n    color: #444258\r\n    border: 1px solid #444258\r\n    border-radius: 20px\r\n    padding: 5px 15px\r\n    font-size: 14px\r\n    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out\r\n\r\n  .custom-error-doc\r\n    background-color: #EC6376\r\n    color: white\r\n    border: none\r\n    border-radius: 20px\r\n    padding: 5px 15px\r\n    font-size: 14px\r\n    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
